export default __webpack_public_path__ + "63ced8693928c061467cbf3925c63550.svg";